if (!window['HRX']) HRX = {};

if (!HRX['NAV']) HRX.NAV = {};

/*focus selector*/
jQuery.expr[':'].focus = function(elem) {
	return elem === document.activeElement && (elem.type || elem.href);
};

;(function($, len, createRange, duplicate) {
	$.fn.caret = function(options, opt2) {
		var start, end, t = this[0],
			browser = $.browser.msie;
		if (typeof options === "object" && typeof options.start === "number" && typeof options.end === "number") {
			start = options.start;
			end = options.end;
		} else if (typeof options === "number" && typeof opt2 === "number") {
			start = options;
			end = opt2;
		} else if (typeof options === "string") {
			if ((start = t.value.indexOf(options)) > -1) end = start + options[len];
			else start = null;
		} else if (Object.prototype.toString.call(options) === "[object RegExp]") {
			var re = options.exec(t.value);
			if (re !== null) {
				start = re.index;
				end = start + re[0][len];
			}
		}
		if (typeof start != "undefined") {
			if (browser) {
				var selRange = this[0].createTextRange();
				selRange.collapse(true);
				selRange.moveStart('character', start);
				selRange.moveEnd('character', end - start);
				selRange.select();
			} else {
				this[0].selectionStart = start;
				this[0].selectionEnd = end;
			}
			this[0].focus();
			return this;
		} else {
            let range, s, e;
			if (browser) {
				var selection = document.selection;
				if (this[0].tagName.toLowerCase() != "textarea") {
					var val = this.val();
                    range = selection[createRange]()[duplicate]();
					range.moveEnd("character", val[len]);
					s = (range.text === "" ? val[len] : val.lastIndexOf(range.text));
					range = selection[createRange]()[duplicate]();
					range.moveStart("character", -val[len]);
					e = range.text[len];
				} else {
					range = selection[createRange]();
					var	stored_range = range[duplicate]();
					stored_range.moveToElementText(this[0]);
					stored_range.setEndPoint('EndToEnd', range);
					s = stored_range.text[len] - range.text[len];
                    e = s + range.text[len];
				}
			} else {
				s = t.selectionStart;
				e = t.selectionEnd;
			}
			var te = t.value.substring(s, e);
			return {
				start: s,
				end: e,
				text: te,
				replace: function(st) {
					return t.value.substring(0, s) + st + t.value.substring(e, t.value[len]);
				}
			};
		}
	};
})(jQuery, "length", "createRange", "duplicate")

/* component plugins*/
;(function($) {
	/* Expendable Textfield */
	$.fn.expandableTextfield = function(options) {
		var opts = $.extend({}, $.fn.expandableTextfield.defaults, options);
		return this.each(function(i) {
			var field = $(this);
			var popupField = null;
			var onfocus = function(e) {
					var offset = field.offset();
					var height = field.height();
					var width = opts.width || field.outerWidth();
					if (opts.widthAnchor) {
						if ($(opts.widthAnchor).length > 0) {
							width = $(opts.widthAnchor).outerWidth() - (offset.left - $(opts.widthAnchor).offset().left) - opts.rightMargin;
						}
					}
					var wrapper = $('<div class="' + opts.wrapperClass + '" style="position:absolute; z-index:100; border:2px solid #afc6e9; background:#f4f7fb;"><h1 style="font-family: Arial,Verdana,Tahoma; font-size: 12px; padding-bottom:7px; color:#214478;">' + opts.header + '</h1><input class="' + opts.popupClass + '"/></div>').css({
						width: width + opts.wrapperPadding * 2 - 20,
						padding: opts.wrapperPadding
					}).appendTo('body');
					wrapper.attr('id', field.attr('id') + 'PopupWrapper');
					if (!opts.freePosition) wrapper.css({
						top: offset.top - opts.wrapperPadding + opts.offsetTop,
						left: offset.left - opts.wrapperPadding + opts.offsetLeft
					});
					popupField = wrapper.children('input').eq(0).val(field.val()).css({
						width: width,
						height: height
					}).keyup(function() {
						field.val($(this).val());
					}).blur(function() {
						field.val($(this).val());
						setTimeout(function() {
							if (!field.is(':focus')) wrapper.remove();
						}, 50);
					});
					popupField.attr('id', field.attr('id') + 'PopupField');
					if (opts.autoFocus) {
						HRX.setSelection(popupField, field.caret().start, field.caret().end);
						popupField.focus();
					}
				};
			$(field).focus(onfocus).keyup(function() {
				if (popupField) popupField.val($(this).val());
			}).blur(function() {
				setTimeout(

				function() {
					if (!popupField.is(':focus')) popupField.parent().remove();
				}, 50)
			});
		});
	};

	$.fn.expandableTextfield.defaults = {
		offsetTop: 0,
		offsetLeft: 0,
		freePosition: false,
		width: null,
		popupClass: 'popupTextfield',
		wrapperClass: 'popupTextfieldWrapper',
		wrapperPadding: 10,
		widthAnchor: "document",
		rightMargin: 10,
		autoFocus: false,
		header: ''
	}; /* End of expandable textfield */
})(jQuery)

/*
 * Auto-growing textareas
 */
;(function($) {
	$.fn.autoGrowTextArea = function(options) {
		var opts = $.extend({}, $.fn.autoGrowTextArea.defaults, options);
		this.filter('textarea').each(function() {
			var $this = $(this),
				minHeight = $this.height(),
				lineHeight = $this.css('lineHeight'),
			    shadow = $('<div></div>').css({
                    position: 'absolute',
                    top: -10000,
                    left: -10000,
                    width: $(this).width() - parseInt($this.css('paddingLeft')) - parseInt($this.css('paddingRight')),
                    fontSize: $this.css('fontSize'),
                    fontFamily: $this.css('fontFamily'),
                    lineHeight: $this.css('lineHeight'),
                    resize: 'none'
                }).after($this);

			var update = function() {
					var times = function(string, number) {
							for (var i = 0, r = ''; i < number; i++) r += string;
							return r;
						};

					var val = this.value.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/\n$/, '<br/>&nbsp;').replace(/\n/g, '<br/>').replace(/ {2,}/g, function(space) {
						return times('&nbsp;', space.length - 1) + ' ';
					});
					shadow.html(val);
					$this.css('height', Math.min(opts.maxHeight, Math.max(shadow.height() + 20, minHeight)));
				};
			$this.change(update).keyup(update).keydown(update);
			update.apply(this);
		});
		return this;
	};

	$.fn.autoGrowTextArea.defaults = {
		maxHeight: 600
	}
})(jQuery);

/**
 * IFrame enhancement
 */

HRX.iframeRedirect = function(selector, url, squirt) {
    var ifm = jQuery(selector);
    if (ifm.size() === 0) return;
    HRX.iframeSquirt(ifm, squirt);
    ifm.attr('src', url);
};

HRX.iframeSquirt = function(selector, squirt) {
    var ifm = jQuery(selector);
    if (ifm.size() === 0) return;
    if (typeof(squirt) !== 'undefined') {
        var el = ifm.get(0);
        var doc = el.contentDocument || el.contentWindow.document;
        doc.open();
        doc.writeln(squirt);
        doc.close();
    }
}

;(function($) {

    var timer;

    $.fn.src = function (url, onLoad, options) {
        setIFrames($(this), onLoad, options, function () {
            this.src = url;
        });
        return $(this);
    };

    $.fn.squirt = function (content, onLoad, options) {

        setIFrames($(this), onLoad, options, function () {
            var doc = null;
            if (typeof(this.contentDocument) != 'unknown') {
                doc = this.contentDocument;
            } else if (typeof(this.contentWindow) != "unknown" && typeof(this.contentWindow.document) != "unknown") {
                doc = this.contentWindow.document;
            }
            if (doc) {
                doc.open();
                doc.writeln(content);
                doc.close();
            }
        });
        return this;
    };

  function setIFrames(iframes, onLoad, options, iFrameSetter) {
    iframes.each(function() {
      if (this.tagName=="IFRAME") setIFrame(this, onLoad, options, iFrameSetter);
    });
  }

  function setIFrame(iframe, onLoad, options, iFrameSetter) {
    var timer;
    iframe.onload = null;
    if (timer) clearTimeout(timer);

    var defaults = {
      timeoutDuration: 0,
      timeout: null
    };
    var opts = $.extend(defaults, options);
    if (opts.timeout && !opts.timeoutDuration) opts.timeoutDuration = 60000;

    opts.frameactive = true;
    var startTime = (new Date()).getTime();
    if (opts.timeout) {
        timer = setTimeout(function() {
        opts.frameactive=false; 
        iframe.onload=null;
        if (opts.timeout) opts.timeout(iframe, opts.timeout);
      }, opts.timeoutDuration);
    }

    var onloadHandler = function() {
      var duration=(new Date()).getTime()-startTime;
      if (timer) clearTimeout(timer);
      if (onLoad && opts.frameactive) onLoad.apply(iframe,[duration]);
      opts.frameactive=false;
    };
    iFrameSetter.apply(iframe);
    iframe.onload = onloadHandler;
    opts.completeReadyStateChanges=0;
    iframe.onreadystatechange = function() { // IE ftw
	    if (++(opts.completeReadyStateChanges)==3) onloadHandler();
    };
    return iframe;
  }

})(jQuery);

/**
 * Navigation
 */
;(function() {
    if (!window['History'] || !History.pushState) return;
    if (!HRX.NAV) HRX.NAV = {};
    var oldIE;
    if (window['Prototype']) {
        oldIE = Prototype.Browser.IE && Prototype.Browser.version < 9;
    } else if (jQuery && jQuery.browser) {
        oldIE = jQuery.browser.ie && jQuery.browser.version < 9
    }
    if (!oldIE) {
        (function() {
            var href = window.location.href;
            var navPos = href.indexOf("&_nav=");
            navPos = navPos >= 0 ? navPos : href.length;
            var startPos = href.indexOf("?");
            HRX.NAV.baseQueryString = href.substr(startPos, navPos - startPos)
        })()
    }
    HRX.NAV.writingBackUrl = false;
    HRX.NAV.pushStateNoOp = function(stateHash) {
        HRX.NAV.writingBackUrl = true;
        if (oldIE) {
            History.pushState(null, "Springboard", '_nav=' + stateHash)
        } else {
            History.pushState(null, "Springboard", HRX.NAV.baseQueryString + '&_nav=' + stateHash)
        }
        HRX.NAV.writingBackUrl = false;
    }
})()
;(function($) {
    if (!window['History'] || !History.options) return;
    $(function() {
        History.options.html4Mode = true;
        History.Adapter.bind(window,'statechange',function(){
            if (!HRX.NAV.writingBackUrl) {
                var state = History.getState().url;
                var navPosition = state.indexOf("_nav=");
                if (navPosition > 0) {
                    state = state.substr(navPosition + 5);
                    a4jNavigateToStateHash(state);
                }
            }
        });
    })
})(jQuery)

//TinyMCE
;(function() {
    if (typeof tinymce === 'undefined') return;
    var defaultOptions = {
        mode: "specific_textareas",
        theme: "advanced",
        plugins: "pagebreak,style,table,save,advhr,advimage,advlink,iespell,insertdatetime,inlinepopups,preview,media,searchreplace,contextmenu,paste,directionality,fullscreen,noneditable,visualchars,nonbreaking,xhtmlxtras,template,advlist,spellchecker,fullpage",
        pagebreak_separator: "<div style=\"page-break-after: always;\"><span style=\"display: none;\"></span></div>",
        theme_advanced_buttons1: "bold,italic,underline,|,justifyleft,justifycenter,justifyright,justifyfull,fontselect,fontsizeselect,forecolor,charmap",
        theme_advanced_buttons2: "cut,copy,paste,pastetext,pasteword,|,search,replace,|,bullist,numlist,|,outdent,indent,|,undo,redo,|,link,unlink,anchor,image,help,code, spellchecker",
        theme_advanced_buttons3_add: "fullpage",
        theme_advanced_buttons4: "",
        theme_advanced_toolbar_location: "top",
        theme_advanced_toolbar_align: "left",
        theme_advanced_statusbar_location: "bottom",
        theme_advanced_resizing: true,
        add_form_submit_trigger: false,
        theme_advanced_path: false,
        spellchecker_languages: "+English=en-AU",
        spellchecker_rpc_url: "/rasp6/jazzy-spellchecker",
        content_css: "css/content.css",
        template_external_list_url: "lists/template_list.js",
        external_link_list_url: "lists/link_list.js",
        external_image_list_url: "lists/image_list.js",
        media_external_list_url: "lists/media_list.js",
        fullpage_default_title: "Springboard Announcement",
        relative_urls : false,
        remove_script_host : false,
        convert_urls : false,
        invalid_elements : "script,javascript,expression,embed,object",
        style_formats: [
            {title: 'Bold text', inline: 'b'},
            {title: 'Red text', inline: 'span', styles: {color: '#ff0000'}},
            {title: 'Red header', block: 'h1', styles: {color: '#ff0000'}},
            {title: 'Example 1', inline: 'span', classes: 'example1'},
            {title: 'Example 2', inline: 'span', classes: 'example2'},
            {title: 'Table styles'},
            {title: 'Table row 1', selector: 'tr', classes: 'tablerow1'}
        ]
    };
    var defaultFinder = function() {return true};

    /**
     * Remove a tinymce editor from the page environment.
     * tinymce.remove (at least up to 3.5.11) does not remove the editor from editors array.
     * We need to do it manually. -- DD 31/03/2016 11:20:04 am
     */
    function removeTinyMCEInstance(editor) {
        var oldLength = tinymce.editors.length;
        tinymce.remove(editor);
        if (oldLength == tinymce.editors.length) {
            tinymce.editors.remove(editor)
        }
    }
    
    HRX.initTinyMCE = function(selector, options, finder) {
        if (!finder) finder = defaultFinder;
        _.chain(tinymce.editors).filter(finder).each(function(e) {
                try {
                    removeTinyMCEInstance(e)
                } catch (err) {
                    app.console.error(err)
                }
            }
        );
        var opt = jQuery.extend(true, {}, defaultOptions, options, {editor_selector: selector});
        tinymce.init(opt)
    };
    
    /**
     * Remove tinymce editors for each id group except the last one.
     */
    HRX.cleanUpTinyMCE = function() {
        _.chain(tinymce.editors)
            .groupBy(function(editor) {return editor.id})
            .values()
            .each(function (editors) {
                _.chain(editors).initial().each(function(leakedEditor) {
                    try {
                        removeTinyMCEInstance(leakedEditor)
                    } catch (err) {
                        app.console.error(err)
                    }
                })
            })
    }
})();

